import React from 'react';
import { useGlobal } from 'reactn';
import Card from '../card/Card';
import Button from '../button/Button';
import FaqIcon from '../../assets/faq-icon.png';

const FAQs = ({ ...rest }) => {
  const [faqs] = useGlobal('faqs');
  const [siteDetails] = useGlobal('siteDetails');
  const { mcwa_all_faqs_url } = siteDetails;
  if (!faqs) {
    return null;
  }
  return (
    <Card title="Quick Links" bodyClassName="justify-between" {...rest}>
      <div>
        <h3 className="uppercase font-bold text-blue-dark">FAQ's</h3>
        {faqs
          // show only first 5 FAQs
          .filter((_, index) => index < 5)
          .map(({ id, link, title }) => {
            return (
              <a
                key={id}
                href={link}
                target="_blank"
                rel="noopener noreferrer"
                className="block w-full my-4"
              >
                {title.rendered}
              </a>
            );
          })}
      </div>
      <Button
        iconUrl={FaqIcon}
        href={mcwa_all_faqs_url || null}
        target="_blank"
        rel="noopener noreferrer"
        className="w-full"
      >
        View All FAQ's
      </Button>
    </Card>
  );
};

export default FAQs;
